export const cross =
  'M19.8,211.3l30.8,30.8l77.3-77.3l77.3,77.3l30.8-30.8L158.8,134l77.3-77.3l-30.8-30.8L128,103.2L50.7,25.8L19.8,56.7L97.2,134L19.8,211.3z'

export const crossCircledSolid =
  'M128.28 12a115.5 115.5 0 1 0 115.5 115.5A115.5 115.5 0 0 0 128.28 12Zm70.46 158.44-28.3 28.3L128 156.29l-42.44 42.45-28.3-28.3L99.71 128 57.26 85.56l28.3-28.3L128 99.71l42.44-42.45 28.3 28.3L156.29 128Z'
